import { FC } from 'react';
import logoSrc from 'src/assets/prisma-logo-short-white-colored-dot.svg';

export const Logo: FC = () => (
  <img alt="logo of Prisma" src={logoSrc} width="110" />
);
